import React, { useEffect } from 'react';
import { graphql } from 'gatsby';
import FacebookPixelEvents from '../services/FacebookPixelEvents';
import { getProductContentIds } from '../data/ProductContentId';
import { SendFacebookConversionsEvent } from '../services/FacebookConversionsApiService';

const ModularFacebookEvent = ({ data }) => {
  const { eventName, productCodes } = data;

  useEffect(() => {
    let facebookEventId = '';
    if (typeof self !== 'undefined') {
      facebookEventId = self.crypto.randomUUID();
    }
    SendFacebookConversionsEvent({
      eventName: eventName,
      eventId: facebookEventId,
      contentIds: getProductContentIds(productCodes),
      contentName: 'product',
    });
    FacebookPixelEvents.track(
      eventName,
      {
        content_ids: getProductContentIds(productCodes),
        content_type: 'product',
      },
      facebookEventId,
    );
  }, []);

  return null;
};

export default ModularFacebookEvent;
export const fragment = graphql`
  fragment ModularFacebookEvent on DatoCmsFacebookEvent {
    internal {
      type
    }
    eventName
    productCodes {
      productCode
    }
  }
`;
